export default __webpack_public_path__ + "136cfe8e.jpg";